var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNovapointTunnelScanDataSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#aeaeb6;}.cls-3{fill:#ff8100;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointTunnelScanData_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,14a4,4,0,0,0-4,4v6h8V18A4,4,0,0,0,16,14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,21.89V17a7.94,7.94,0,0,0-.45-2.63,8.18,8.18,0,0,0-.79-1.63,8,8,0,0,0-1.59-1.84,9,9,0,0,0-.94-.68,8,8,0,0,0-2.72-1.07A7.51,7.51,0,0,0,16,9h-.23a8,8,0,0,0-6.31,3.4,7.67,7.67,0,0,0-1,1.84A7.85,7.85,0,0,0,8,17V27h2V17a6,6,0,0,1,12,0V27h2V21.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28,17c0-1-3.12-3-2.33-3.71s-2.58-.46.6-2.47l.08-.06A1,1,0,0,1,26,10a1,1,0,0,1,.15-.5c-.67-.59-1.84-1.18-2.39-1.66-.25-.2-.5-.59-.77-.84a1,1,0,0,1-.56-.2s-.05,0-.08,0c-3.52,1.91-3-.27-3.57-1.22a.95.95,0,0,1-1.38.18c-.22.31-.41.63-.63.57l-2.27-.5A1,1,0,0,1,14,6a1.55,1.55,0,0,1-.21,0C14.63,9.07,9.25,8.59,7,9.05a1,1,0,0,1-.87.93.67.67,0,0,0,.06.12c.31.45-.61,1-1.27,1.49A1.07,1.07,0,0,1,5,12a1,1,0,0,1-.4.78l.14.08c1.2.53,2.4,1.7,0,3.9a2,2,0,0,0-.65,1.63l.34,4.43a1.6,1.6,0,0,1,0,.38L4,27H8V17a7.85,7.85,0,0,1,.5-2.75,7.67,7.67,0,0,1,1-1.84A8,8,0,0,1,15.77,9H16a7.51,7.51,0,0,1,1.51.15,8,8,0,0,1,2.72,1.07,9,9,0,0,1,.94.68,8,8,0,0,1,1.59,1.84,8.18,8.18,0,0,1,.79,1.63A7.94,7.94,0,0,1,24,17V27h4l-.71-4.77a2.32,2.32,0,0,1,0-.59Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 4,
    cy: 12,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 14,
    cy: 5,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27,
    cy: 10,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 23,
    cy: 6,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18,
    cy: 5,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 6,
    cy: 9,
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointTunnelScanDataSvg);
export default __webpack_public_path__ + "static/media/NovapointTunnelScanData_svg.4afa4a6c2b866e346ddb3600c6590869.svg";
export { ForwardRef as ReactComponent };